import { StateBadge } from "@components/shared/StateBadge";
import { FileText, Lock, Pencil } from "lucide-react";

interface Props {
  locked: boolean;
  hasPriorLock: boolean;
}

export function BlueprintStateBadge({ locked, hasPriorLock }: Props) {
  if (locked) {
    return (
      <StateBadge
        label="Locked"
        tone="warning"
        icon={<Lock size={10} />}
        title="Blueprint is locked. Unlock to edit."
      />
    );
  }
  if (hasPriorLock) {
    return (
      <StateBadge
        label="Editing"
        tone="info"
        icon={<Pencil size={10} />}
        title="Previously locked. Re-lock to publish a new version."
      />
    );
  }
  return (
    <StateBadge
      label="Draft"
      tone="muted"
      icon={<FileText size={10} />}
      title="Draft blueprint — not yet locked."
    />
  );
}
